import { createContext } from 'react'
import type { Context } from 'react'
import type { HubStateType } from 'storeContext/reducers/hub/types'
import type { HubDispatchType } from 'storeContext/actions/hub/types'

export type HubContextValueType = { state: HubStateType; dispatch: HubDispatchType }

// Preserve the raw-state default and existing Provider identity.
export const createHubContext = (initialState: HubStateType) =>
  createContext(initialState) as unknown as Context<HubContextValueType>
